import React from 'react';
import CloseIcon from '../assets/close.svg';
import './Modal.css';

class Modal extends React.Component {
    render() {
        console.log(this.props)
        return (
            <>
                <div className='modal-backdrop-login-profile'></div>
                <div className='modal-container-login-profile'>
                    <img src={CloseIcon} alt='close' onClick={this.props.handleClose} />
                    <div className='modal-body-login-profile'>
                        <h2>That code wasn’t valid.</h2>
                        <p>Please try again</p>
                        <button className='modal-button-login-profile' onClick={this.props.handleSendNow}>SEND NEW CODE</button>
                    </div>
                </div>
            </>
        )
    }
}

export default Modal;